module.exports = __webpack_public_path__ + "img/logoDocker.3a19d379.svg";